module.exports = __webpack_public_path__ + "static/media/31.87069ae9.jpg";